/* eslint-disable i18next/no-literal-string */
/* eslint-disable react/no-unescaped-entities */
export const PrivacyPolicyFr = () => (
  <div className="WordSection1">
    <div>
      <h2>
        <span lang="FR-CA">Politique de confidentialité de Carson</span>
      </h2>

      <h4>
        <span lang="FR-CA">Dernière modification : Mai 2021</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Toute référence à &quot;Carson&quot;, &quot;nous&quot;,
          &quot;notre&quot; ou &quot;nos&quot; fait référence à Carson Living,
          Inc. Carson respecte votre confidentialité en tant qu'utilisateur de
          ce site. La présente politique de confidentialité explique quelles
          informations personnelles nous recueillons auprès de vous, comment
          nous utilisons ces informations et quelle est notre base juridique
          pour ce faire. Cette politique détaille également les choix qui
          s'offrent à vous concernant l'utilisation de vos informations
          personnelles, ainsi que la manière dont vous pouvez accéder à ces
          informations et les mettre à jour. Cette politique de confidentialité
          sera facile à trouver sur la page d'accueil publique de Carson et sur
          toute page où nous demandons des informations pour l'utilisation du
          site.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">
          Quels sont les services couverts par la politique de confidentialité?{' '}
        </span>
      </h4>

      <p>
        <span lang="FR-CA">
          Cette politique s'applique à tous les produits Carson, y compris
          toutes les applications Carson, ainsi qu'au site Web ({' '}
        </span>
        <span lang="EN-US">
          <a href="http://www.Carson.live" target="_blank" rel="noreferrer">
            <span lang="FR-CA">www.Carson.live</span>
          </a>
        </span>
        <span lang="FR-CA">
          ) et au logiciel Carson (collectivement la &quot;Plateforme&quot;
          Carson).{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Clients et utilisateurs </span>
      </h4>

      <p>
        <span lang="FR-CA">
          Notre &quot;client&quot; est généralement une entité juridique
          représentant un édifice ou une propriété. Les clients achètent ou
          licencient un ou plusieurs produits ou services qui font partie de la
          plateforme. Vous êtes un utilisateur de la plateforme. Carson
          recueille des informations auprès de ses clients et des utilisateurs
          au nom de ses clients. Il existe de nombreux types d'utilisateurs et
          chacun d'entre eux a une relation unique avec les informations que
          nous collectons. Les utilisateurs peuvent être les employés de nos
          clients (personnel de l'édifice, personnel d'entretien, gestionnaires,
          etc.), les résidents (locataires, propriétaires, sous-locataires,
          invités, etc.), les fournisseurs de services (entrepreneurs
          extérieurs, entreprises locales, etc.) et d'autres personnes. Chacun
          d'entre eux (et généralement toute personne possédant un nom
          d'utilisateur et un mot de passe Carson) est considéré comme un
          &quot;utilisateur enregistré&quot;. Certains utilisateurs peuvent ne
          pas être des utilisateurs enregistrés, comme les visiteurs de notre
          site Web public. La plupart des utilisateurs enregistrés sont affiliés
          à un ou plusieurs clients de Carson (c'est-à-dire vos édifices).
          Carson est le dépositaire des données pour le compte de nos clients,
          en ce qui concerne la plupart des informations que nous recueillons.
          Chaque client détermine également ses propres politiques en matière de
          collecte, d'accès, de partage et de conservation des informations.
          Veuillez contacter le client si vous avez des questions concernant ses
          pratiques en matière de confidentialité.
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Les informations que nous recueillons</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Pour que vous puissiez utiliser la plateforme Carson, nous devons
          collecter et traiter certaines informations (telles que votre nom ou
          votre adresse) et des informations anonymes (telles que votre adresse
          IP). La plupart de ces informations sont fournies par nos clients ou
          par vous, lorsque vous utilisez notre plateforme. Certaines
          informations sont obtenues par le biais de votre utilisation de notre
          plateforme, par exemple lorsque nous recevons des rapports d'erreur ou
          utilisons des témoins (voir ci-dessous).{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Enfin, nous recevons certaines informations de la part d'autres
          utilisateurs enregistrés. C'est le cas par exemple lorsqu'un
          utilisateur enregistré soumet ou modifie les informations et les
          paramètres de divers tiers non membres, tels que des membres de la
          famille, des colocataires ou d'autres personnes concernées par la
          gestion de l'édifice et qu'il souhaite soumettre par l'intermédiaire
          de Carson (par exemple, l'aide ménagère, les nettoyeurs, les
          concierges). Il peut également y avoir des informations personnelles
          soumises par nos clients au sujet de nos utilisateurs enregistrés,
          auxquelles les utilisateurs enregistrés ne peuvent pas accéder
          directement.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Les types d'informations que nous recueillons dépendent de votre
          niveau d'accès et d'engagement avec la plateforme Carson et peuvent
          inclure :{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Les informations de contact telles que les noms, les adresses
          courriel, les adresses postales et les numéros de téléphone.{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Identifiants uniques tels que noms d'utilisateur, mots de passe,
          numéros de compte Carson{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Les informations de base soumises par vous ou en votre nom, telles que
          les descriptions des demandes de services{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Les informations que vous avez téléchargées, telles que les documents
          joints à la plateforme Carson{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Si vous choisissez d'utiliser des services de connexion tels que
          Facebook Connect, ces services authentifieront votre identité et vous
          donneront la possibilité de partager certaines informations
          personnelles avec nous, telles que votre nom et votre adresse
          courriel.{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Si vous choisissez d'utiliser la connexion unique (SSO) de Carson avec
          des fournisseurs tiers tels que Clickpay ou Aptexx, ces services
          authentifieront votre identité et vous donneront la possibilité
          d'accéder à ces services tiers tels que Clickpay ou Aptexx. Carson ne
          stocke pas, ne transmet pas et ne traite pas vos informations de
          paiement ou autres informations personnelles. Clickpay et Aptexx et
          des fournisseurs tiers similaires traitent vos informations de
          paiement ou d'autres informations conformément à leurs politiques de
          confidentialité respectives,{' '}
        </span>
        <span lang="EN-US">
          <a
            href="https://site.clickpay.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">ici </span>
          </a>
        </span>
        <span lang="FR-CA">et </span>
        <span lang="EN-US">
          <a
            href="https://aptexx.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">ici </span>
          </a>
        </span>
        <span lang="FR-CA">. </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vos communications avec nous, telles que vos demandes d'assistance à
          la clientèle{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Des informations sur votre utilisation, telles que les adresses IP, le
          type de navigateur, l'horodatage et les données relatives au parcours
          de navigation{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Des informations sur l'emploi des employés du client (y compris le
          titre, le nom et le numéro de téléphone){' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Des photographies (de résidents, d'employés, d'animaux domestiques, de
          visiteurs, de pièces jointes à une demande d'entretien){' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Des scans (licence, carte de visite) dans le cadre de l'édifice
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">Des détails et informations sur l'incident</span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Des instructions pour les résidents (y compris l'autorisation
          d'entrer, l'autorisation pour les visiteurs autorisés, les paramètres
          d'appel de l'interphone){' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Témoins</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Nous utilisons des témoins sur ce site pour fournir aux utilisateurs
          des services personnalisés. Les témoins sont de petites quantités de
          données envoyées au navigateur d'un utilisateur par un site Web et
          stockées sur le disque dur de l'utilisateur à des fins d'archivage.
          Ces informations n'identifient pas nécessairement l'utilisateur, mais
          identifient l'ordinateur de l'utilisateur. Les témoins utilisés ne
          collectent pas d'informations personnelles telles que le nom,
          l'adresse ou le numéro de téléphone.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">
          Notre utilisation de témoins et d'autres technologies de suivi
        </span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons à la fois des témoins d'identification de session et
          des témoins persistants. Un témoin d'identification de session expire
          lorsque vous fermez votre navigateur. Un témoin persistant reste sur
          votre disque dur pendant une longue période. Vous pouvez supprimer les
          témoins persistants en suivant les instructions fournies dans le
          répertoire d'aide de votre navigateur Internet. Si vous refusez les
          témoins, vous pouvez toujours utiliser notre site, mais votre capacité
          à utiliser certaines parties de notre site sera limitée.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Balises Web / GIF</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Les sociétés tierces spécialisées dans les technologies de suivi
          utilisent une technologie logicielle appelée &quot;clear gifs&quot;
          (ou balises Web), qui nous aident à mieux gérer le contenu de notre
          site en nous informant de l'efficacité du contenu. Les gifs invisibles
          sont de minuscules graphiques dotés d'un identifiant unique, dont la
          fonction est similaire à celle des témoins, et qui sont utilisés pour
          suivre les mouvements en ligne des utilisateurs du Web. Contrairement
          aux témoins, qui sont stockés sur le disque dur de l'ordinateur de
          l'utilisateur, les gifs invisibles sont intégrés de manière invisible
          dans les pages Web et ont à peu près la taille du point à la fin de
          cette phrase. Nous ne lions pas les informations recueillies par les
          gifs invisibles aux informations personnelles identifiables de nos
          clients.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Analyse / Fichiers journaux </span>
      </h5>

      <p>
        <span lang="FR-CA">
          Comme c'est le cas pour la plupart des sites Web, nous recueillons
          automatiquement certaines informations et les stockons dans des
          fichiers journaux. Ces informations comprennent les adresses de
          protocole Internet (IP), le type de navigateur, le fournisseur d'accès
          à Internet (FAI), les pages de renvoi et de sortie, le système
          d'exploitation, l'horodatage et les données relatives au parcours de
          navigation. Nous utilisons ces informations, qui n'identifient pas les
          utilisateurs individuels, pour analyser les tendances, administrer le
          site, suivre les mouvements des utilisateurs sur le site et recueillir
          des informations démographiques sur l'ensemble de notre base
          d'utilisateurs. Nous n'établissons pas de lien entre ces données
          collectées automatiquement et des informations personnellement
          identifiables.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Suivi par un tiers</span>
      </h5>

      <p>
        <span lang="FR-CA">
          L'utilisation de technologies de suivi par nos fournisseurs de
          services, nos partenaires technologiques ou d'autres actifs de tiers
          (tels que les widgets et les plug-ins de médias sociaux) sur le site
          n'est pas couverte par notre politique de confidentialité. Ces tiers
          peuvent utiliser des témoins, des gifs invisibles, des images et des
          scripts pour les aider à mieux gérer leur contenu sur notre site. Nous
          n'avons ni accès ni contrôle sur ces technologies. Nous ne lions pas
          les informations recueillies aux informations personnelles
          identifiables de nos clients ou utilisateurs.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Bases juridiques de la collecte d'informations</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Nous traitons les données à caractère personnel pour où sur la base
          d'une ou plusieurs des bases juridiques suivantes :{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Exécution d'un contrat</span>
      </h5>

      <p className="MsoNormal">
        <span lang="FR-CA">
          Nous utilisons les données personnelles pour conclure et exécuter un
          contrat entre Carson et le client.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Intérêts légitimes</span>
      </h5>

      <p className="MsoNormal">
        <span lang="FR-CA">
          Nous utilisons les données personnelles pour nos intérêts légitimes, y
          compris les informations de contact, les services offerts et les
          données d'utilisation du site Web.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">
          Respect des obligations légales et protection des personnes
        </span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous pouvons utiliser des données à caractère personnel pour nous
          conformer à la loi et à nos obligations légales, ainsi que pour vous
          protéger, vous et d'autres personnes, contre certains préjudices.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Votre consentement</span>
      </h5>

      <p className="MsoNormal">
        <span lang="FR-CA">
          Nous traitons certaines données à caractère personnel parce que vous
          nous avez donné votre accord pour les traiter de cette manière.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Pourquoi nous collectons vos informations</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Carson utilise les informations qu'elle recueille dans le cadre de
          tous ses services aux fins suivantes :{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Personnaliser nos services</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons vos informations pour fournir nos services et les
          personnaliser pour chaque utilisateur enregistré ou client.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Maintenir et améliorer nos services</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons également vos informations pour nous assurer que notre
          Plateforme fonctionne comme prévu, par exemple pour suivre les pannes
          ou résoudre les problèmes que vous nous signalez. Nous utilisons vos
          informations pour améliorer nos services.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Fournir des services personnalisés</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons les informations que nous recueillons pour
          personnaliser nos services.
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Mesurer la performance</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons les données à des fins d'analyse et de mesure pour
          comprendre comment nos services sont utilisés. Par exemple, nous
          analysons les données relatives au temps que vous passez à accéder à
          la plateforme afin d'en optimiser la conception.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Communiquer avec vous</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons les informations que nous recueillons, comme votre
          adresse courriel, pour interagir directement avec vous. Par exemple,
          nous pouvons vous envoyer une notification si nous détectons une
          activité suspecte, comme une tentative de connexion à votre compte
          Carson à partir d'un lieu inhabituel. Il se peut aussi que nous vous
          informions de changements ou d'améliorations à venir dans nos
          services. Si vous contactez Carson, nous conserverons une trace de
          votre demande afin de vous aider à résoudre les problèmes que vous
          pourriez rencontrer.{' '}
        </span>
      </p>

      <h5>
        <span lang="FR-CA">Protéger Carson, nos utilisateurs et le public</span>
      </h5>

      <p>
        <span lang="FR-CA">
          Nous utilisons les informations pour améliorer la sécurité et la
          fiabilité de nos services. Cela inclut la détection, la prévention et
          la réponse à la fraude, aux abus, aux risques de sécurité et aux
          problèmes techniques qui pourraient nuire à Carson, à nos clients, aux
          utilisateurs enregistrés ou au public.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Nous utilisons différentes technologies pour traiter vos informations
          à ces fins. Nous utilisons des systèmes automatisés qui analysent
          votre contenu afin de vous fournir des services personnalisés ou
          d'autres fonctions adaptées à la façon dont vous utilisez nos
          services. Nous analysons votre contenu pour nous aider à détecter les
          abus tels que le pourriel, les logiciels malveillants et le contenu
          illégal.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Nous pouvons combiner les informations que nous recueillons sur notre
          plateforme et sur vos appareils aux fins décrites ci-dessus. Si
          d'autres utilisateurs enregistrés disposent déjà de votre adresse
          courriel ou d'autres informations permettant de vous identifier, nous
          pouvons leur montrer les informations de votre compte Carson visibles
          par le public, telles que votre nom et votre photo. Cela permet aux
          gens d'identifier un courriel provenant de vous, par exemple.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Nous vous demanderons votre consentement avant d'utiliser vos
          informations à des fins qui ne sont pas couvertes par la présente
          politique de confidentialité.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Comment nous utilisons les informations</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Pour les utilisateurs de la plateforme, nous utilisons les
          informations que nous recevons pour :
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">Fournir les services demandés par notre client</span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vous avertir des activités liées à votre compte, par exemple lorsqu'un
          colis est livré à la propriété pour vous{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">Administrer votre compte</span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Assurer la sécurité de votre compte (notamment pour vérifier votre
          identité et prévenir la fraude){' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Répondre aux demandes de service et d'assistance des clients
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Créer et fournir des produits et services meilleurs et améliorés en
          fonction de votre utilisation du site et de vos commentaires{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vous faire figurer dans notre annuaire des membres, accessible
          uniquement aux autres membres de votre édifice{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">Effectuer des recherches et des analyses</span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vous envoyez notre infolettre, que vous pouvez refuser à tout moment
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Pour les visiteurs qui demandent des informations sur nos produits et
          services à partir de l'un de nos sites Web, nous utilisons les
          informations que nous recevons pour :{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Évaluer les besoins de votre entreprise pour déterminer les produits
          adéquats
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vous envoyer les informations demandées sur les produits ou les
          services
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">Vous envoyer des communications marketing</span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Vous envoyez notre infolettre, que vous pouvez refuser à tout moment
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Si vous nous fournissez des informations personnelles sur d'autres
          personnes, ou si d'autres personnes nous fournissent vos informations,
          nous n'utiliserons ces informations que pour la raison spécifique pour
          laquelle elles nous ont été fournies.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">
          Avis de confidentialité pour les résidents de Californie&nbsp;
        </span>
      </h4>

      <p>
        <span lang="FR-CA">
          Les droits d'accès et de choix de l'utilisateur suivants sont des
          obligations de Carson lorsque nous sommes l'&quot;entreprise&quot; au
          sens de la CCPA (c'est-à-dire en ce qui concerne les informations
          personnelles décrites ci-dessus sous la légende &quot;Informations
          personnelles que nous traitons en tant que responsable du traitement
          ou entreprise&quot;). En ce qui concerne toutes les autres
          informations personnelles décrites dans le présent document, les
          droits d'accès et de choix sont traités de manière appropriée entre
          vous et notre client concerné, sous réserve de la politique de
          confidentialité de ce dernier.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Les résidents de l'État de Californie peuvent demander des
          informations concernant les catégories d'informations personnelles que
          nous recueillons à leur sujet, les catégories de sources à partir
          desquelles nous obtenons les informations personnelles, les objectifs
          commerciaux pour lesquels les informations personnelles sont
          recueillies et les catégories de tiers avec lesquels nous partageons
          ou, dans le cas où nous vendons des informations personnelles, par
          catégorie d'informations personnelles vendues à ces parties,
          respectivement.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Sur demande vérifiable, lorsque cela est nécessaire ou approprié, et
          dans les délais (le cas échéant) fixés par la législation applicable,
          nous vous accorderons un accès raisonnable, des copies ou d'autres
          compilations des éléments spécifiques des informations personnelles
          que nous détenons à votre sujet, à condition que vous établissiez, à
          notre satisfaction raisonnable, que vous êtes la personne dont les
          informations personnelles sont demandées. Nous pouvons refuser cet
          accès lorsque le refus est autorisé par la loi applicable et chaque
          demande émanant d'une personne sera évaluée au cas par cas. En cas de
          refus d'une demande, nous vous informerons par écrit des raisons de ce
          refus. Conformément à la manière dont vos informations personnelles
          sont conservées dans le cours normal de nos activités, nous fournirons
          les informations sous une forme compréhensible et, dans la mesure du
          possible, dans un format qui vous permettra d'utiliser les
          informations sur d'autres systèmes. Nous pouvons imposer des frais
          raisonnables lorsqu'une demande est faite (par exemple, pour les
          photocopies ou l'affranchissement) dans la mesure où la loi applicable
          le permet.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Nous prendrons des mesures raisonnables pour vous permettre de
          corriger ou de modifier les informations personnelles dont il est
          démontré qu'elles sont inexactes ou incomplètes. Nous supprimerons
          également les informations personnelles que nous avons recueillies à
          votre sujet lorsque vous nous en ferez la demande vérifiable, sauf
          dans la mesure où la loi applicable autorise ou nous oblige à
          conserver ces informations.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Pour éviter les demandes d'accès frauduleuses, nous exigerons des
          informations suffisantes pour nous permettre de confirmer l'identité
          de la personne qui fait la demande avant d'accorder l'accès ou de
          supprimer les informations. Nous n'exercerons aucune discrimination à
          l'encontre des consommateurs qui exercent leurs droits en vertu de la
          loi californienne. Toutefois, nous pouvons facturer des prix
          différents ou fournir des biens ou des services de qualité différente
          si la différence est raisonnablement liée à la valeur fournie par vos
          informations personnelles.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Avis Ne pas tracer de la Californie : À l'heure actuelle, il n'existe
          pas de norme ou de définition industrielle uniforme ou cohérente à
          l'échelle mondiale pour répondre aux signaux Ne pas tracer, les
          traiter ou les communiquer. Ainsi, comme beaucoup d'autres sites Web
          et services en ligne, notre plateforme n'est actuellement pas en
          mesure de répondre aux signaux Ne pas tracer. Pour en savoir plus sur
          &quot;Ne pas tracer&quot;, vous pouvez consulter le site{' '}
        </span>
        <span lang="EN-US">
          <a
            href="http://www.allaboutdnt.com/"
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">http://www.allaboutdnt.com . </span>
          </a>
        </span>
        <span lang="EN-US"> </span>
      </p>

      <h4>
        <span lang="FR-CA">Utilisateurs de l'Union européenne</span>
      </h4>

      <p>
        <span lang="FR-CA">
          La législation européenne en matière de protection des données exige
          une &quot;base légale&quot; pour la collecte, le traitement et le
          transfert d'informations personnelles provenant de citoyens ou de
          résidents de l'Espace économique européen (EEE). Nos bases légales,
          telles que détaillées ci-dessus, comprennent l'exécution de notre
          contrat avec nos clients <br />, le consentement de l'utilisateur (qui
          est toujours facile à retirer) et nos intérêts légitimes (sauf si ces
          intérêts sont supplantés par les intérêts ou les droits et libertés
          fondamentaux de nos utilisateurs de l'UE).{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Pour nos utilisateurs de l'U.E : Nous participons au bouclier de
          protection confidentialité entre l'Union européenne et les E-U (voir
          la déclaration ci-dessous), et la présente politique de
          confidentialité indique que nous respectons les principes du bouclier
          de confidentialité. En conséquence, Carson est responsable du
          traitement des informations qu'elle reçoit conformément au cadre du
          bouclier de protection de confidentialité et qu'elle transfère ensuite
          à un tiers agissant en son nom (par exemple, un fournisseur de
          services). Il nous incombe de veiller à ce que les fournisseurs de
          services auxquels nous faisons appel adhèrent également à ces
          principes.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Fournisseurs de services</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Nous ne partageons vos informations personnelles qu'avec votre
          consentement ou si cela est nécessaire pour mener à bien une
          transaction ou fournir un produit que vous avez demandé ou autorisé.
          Nous pouvons fournir vos informations personnelles à des sociétés qui
          fournissent des services pour nous aider à fournir nos services tels
          que le traitement des paiements (Stripe), l'hébergement d'applications
          ou l'exécution d'autres fonctions du site Web. Ces fournisseurs de
          services tiers sont limités à l'accès ou à l'utilisation de ces
          informations uniquement dans le but de nous fournir des services,
          ainsi qu'à vous, et doivent fournir des garanties raisonnables qu'ils
          protégeront de manière appropriée toutes les informations. Par
          exemple, nous transférons des numéros de téléphone anonymes à notre
          fournisseur de communications Twilio, qui se charge des appels et des
          messages texte pour notre service de portier virtuel et les
          notifications de l'édifice. Vous pouvez consulter la politique de
          confidentialité de Twilio{' '}
        </span>
        <span lang="EN-US">
          <a
            href="https://www.twilio.com/legal/privacy"
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">ici</span>
          </a>
        </span>
        <span lang="FR-CA">. </span>
      </p>

      <h4>
        <span lang="FR-CA">Informations agrégées</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Vos informations personnelles ne sont ni vendues ni louées à des tiers
          sans votre autorisation expresse. Nous nous réservons le droit de
          partager des informations démographiques et/ou statistiques agrégées
          non identifiantes avec des partenaires, des annonceurs et des
          commanditaires. Nous pouvons utiliser des informations non
          identifiantes et agrégées pour améliorer votre expérience sur le site
          Web et pour les partager avec des partenaires, des annonceurs et des
          commanditaires. Par exemple, toute information personnelle restera
          chez nous, mais votre visite peut être comptabilisée pour déterminer
          le nombre de visiteurs d'une page ou d'une zone particulière du site.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Liens vers des tiers</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Sites Notre plateforme comprend des liens vers d'autres sites Web dont
          les pratiques en matière de confidentialité peuvent différer de celles
          de Carson. Si vous soumettez des informations personnelles à l'un de
          ces sites, vos informations sont régies par leurs politiques de
          confidentialité. Nous vous encourageons à lire attentivement la
          politique de confidentialité de tout site Web que vous visitez.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Avis de non-responsabilité</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Nous pouvons divulguer vos informations personnelles :
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Si la loi l'exige, par exemple pour se conformer à une citation à
          comparaître ou à une procédure judiciaire similaire{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Lorsque nous estimons de bonne foi que la divulgation est nécessaire
          pour protéger nos droits, votre sécurité ou celle d'autrui, enquêter
          sur des fraudes ou répondre à une demande du gouvernement{' '}
        </span>
      </p>

      <p style={{ marginLeft: '36pt', textIndent: '-18.0pt' }}>
        <span lang="EN-US" style={{ fontSize: '10.0pt', fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <span lang="FR-CA">
          Si Carson est impliqué dans une fusion, une acquisition ou une vente
          de tout ou partie de ses actifs, vous serez informé par courriel et/ou
          par un avis bien visible sur notre site Web de tout changement de
          propriété ou d'utilisation de vos informations personnelles, ainsi que
          de tout choix que vous pourriez avoir concernant vos informations
          personnelles.{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Carson ne conservera les données personnelles que nous traitons au nom
          de nos clients que pendant la durée nécessaire à la fourniture des
          services et au respect de nos obligations légales, à la résolution des
          litiges et à l'application de nos accords.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Accès et choix de l'utilisateur</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Les utilisateurs résidant dans certains pays, y compris en Europe,
          bénéficient de certains droits concernant leurs informations
          personnelles. Ces droits comprennent le droit d'accéder à vos
          informations personnelles, de les corriger et de demander leur
          suppression. Bien que ces droits ne soient pas applicables dans le
          monde entier, tous les utilisateurs enregistrés de Carson peuvent
          gérer leurs informations personnelles comme décrit ci-dessous. <br />
          <br />
          Vous pouvez accéder à certaines informations personnelles, les
          corriger, les mettre à jour, les modifier ou les supprimer en
          effectuant le changement sur la page des paramètres de votre compte
          d'utilisateur ou en demandant à votre gestionnaire immobilier (ou
          autre administrateur de programme) d'effectuer ce changement en votre
          nom. Votre compte est protégé par un mot de passe. Nous vous
          encourageons à choisir votre mot de passe avec soin et à le conserver
          en toute sécurité. Si vous avez des difficultés à accéder à votre
          compte ou à vos informations, vous pouvez contacter Carson en envoyant
          un courriel à notre équipe d'assistance à la clientèle à l'adresse{' '}
        </span>
        <span lang="EN-US">
          <a href="mailto:support@carson.live" target="_self">
            <span lang="FR-CA">support@carson.live .</span>
          </a>
        </span>
        <span lang="EN-US"> </span>
      </p>

      <h4>
        <span lang="FR-CA">Choix de retrait</span>
      </h4>

      <p className="MsoNormal">
        <span lang="FR-CA">
          Carson vous offre des choix concernant la collecte, l'utilisation et
          le partage de vos informations personnelles. En vertu des principes du
          bouclier de protection de confidentialité, vous avez le droit de
          refuser i) la divulgation de vos informations personnelles à des
          fournisseurs tiers non identifiés au moment de la collecte ou
          autorisés ultérieurement, ou ii) l'utilisation de vos informations
          personnelles dans la mesure où vous n'êtes pas exigé de fournir des
          données personnelles. Si vous n'avez plus besoin de nos services ou si
          vous souhaitez que vos informations personnelles soient supprimées,
          veuillez nous contacter en utilisant les méthodes directes
          susmentionnées. Les procédures de cessation de service sont menées
          hors ligne et sont soumises à l'approbation de notre client, si vous
          êtes un résident ou un membre du personnel. Nous répondrons à votre
          demande dans un délai de trente (30) jours.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">
          Notre engagement en faveur de la confidentialité des enfants
        </span>
      </h4>

      <p>
        <span lang="FR-CA">
          La protection de la confidentialité des très jeunes est
          particulièrement importante. C'est pourquoi nous ne recueillons ni ne
          conservons jamais d'informations sur notre site Web auprès de
          personnes dont nous savons qu'elles ont moins de 13 ans, et aucune
          partie de notre site Web n'est structurée de manière à attirer des
          personnes de moins de 13 ans.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">
          Le bouclier de protection de confidentialité UE - E.U,
        </span>
      </h4>

      <p>
        <span lang="FR-CA">
          Carson se conforme au cadre du bouclier de protection de
          confidentialité de l'U.E et des E.U, tel que défini par le ministère
          américain du Commerce, en ce qui concerne la collecte, l'utilisation
          et la conservation des informations personnelles provenant de l'Union
          européenne. Carson a certifié au ministère du Commerce qu'elle adhère
          aux principes du bouclier de protection de confidentialité. En cas de
          conflit entre la présente politique de confidentialité et les
          principes du bouclier de confidentialité, ce sont les principes du
          bouclier de confidentialité qui prévalent. Pour en savoir plus sur le
          bouclier de protection de confidentialité entre l'Union européenne et
          les États-Unis et pour consulter notre certification, veuillez
          consulter le site{' '}
        </span>
        <span lang="EN-US">
          <a
            href="http://www.privacyshield.gov"
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">www.privacyshield.gov. </span>
          </a>
        </span>
        <span lang="FR-CA">
          Pour toute question, commentaire, plainte, demande d'accès ou tout
          autre problème lié au bouclier de protection de confidentialité ou à
          notre politique de confidentialité, veuillez envoyer un courriel à{' '}
        </span>
        <span lang="EN-US">
          <a href="mailto:privacy@carson.live">
            <span lang="FR-CA">privacy@carson.live </span>
          </a>
        </span>
        <span lang="FR-CA">ou appeler le </span>
        <span lang="EN-US">
          <a href="tel:+1%20(646)%20661-2250" target="_self">
            <span lang="FR-CA">+1 (646) 661-2250. </span>
          </a>
        </span>
        <span lang="FR-CA">
          Pour tout problème qui ne peut être résolu directement par Carson,
          vous pouvez contacter JAMS à l'adresse suivante :{' '}
        </span>
        <span lang="EN-US">
          <a
            href="https://www.jamsadr.com/eu-us-privacy-shield."
            target="_blank"
            rel="noreferrer"
          >
            <span lang="FR-CA">
              https://www.jamsadr.com/eu-us-privacy-shield .{' '}
            </span>
          </a>
        </span>
        <span lang="FR-CA">
          Si vos préoccupations ne sont toujours pas prises en compte par JAMS,
          vous pouvez avoir droit à un arbitrage contraignant en vertu des
          principes du bouclier de protection de confidentialité. La Federal
          Trade Commission (FTC) est compétente en matière de respect du
          bouclier de protection de confidentialité par Carson.{' '}
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Addendum sur la protection des données&nbsp;</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Pour aider nos clients de l'EEE à se conformer à la législation
          applicable en matière de protection des données, nous proposons un
          addendum sur le traitement des données (DPA) à notre contrat
          d'abonnement. Pour demander une DPA, contactez-nous à l'adresse
          suivante{' '}
        </span>
        <span lang="EN-US">
          <a href="mailto:privacy@carson.live">
            <span lang="FR-CA">privacy@carson.live .</span>
          </a>
        </span>
        <span lang="EN-US"> </span>
      </p>

      <h4>
        <span lang="FR-CA">Agent à la protection des données</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Pour contacter notre agent à la protection des données, veuillez
          envoyer un courriel à{' '}
        </span>
        <span lang="EN-US">
          <a href="mailto:privacy@carson.live">
            <span lang="FR-CA">privacy@carson.live .</span>
          </a>
        </span>
        <span lang="EN-US"> </span>
      </p>

      <h4>
        <span lang="FR-CA">Modifications de cette politique</span>
      </h4>

      <p>
        <span lang="FR-CA">
          Nous pouvons mettre à jour cette politique de confidentialité afin de
          refléter les changements apportés à nos pratiques en matière
          d'information. Si nous apportons des modifications importantes, nous
          vous en informerons par courriel (envoyé à l'adresse courriel
          spécifiée dans votre compte ou par le biais d'un avis sur cette page
          avant que la modification n'entre en vigueur.) Nous vous encourageons
          à consulter régulièrement cette page pour obtenir les dernières
          informations sur notre politique en matière de confidentialité
        </span>
      </p>

      <h4>
        <span lang="FR-CA">Nous contacter</span>
      </h4>

      <p className="MsoNormal">
        <span lang="FR-CA">
          Courrier&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;88
          University Pl., 10e étage{' '}
        </span>
      </p>

      <p>
        <span lang="FR-CA">
          Adresse&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;New York,
          N.Y. 10003&nbsp;&nbsp;
        </span>
      </p>

      <p>
        <span lang="FR-CA">Téléphone&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span lang="EN-US">
          <a href="tel:+1%20(646)%20661-2250" target="_self">
            <span lang="FR-CA">+1 (646) 661-2250 </span>
          </a>
        </span>
        <span lang="FR-CA">
          <br />
          Courriel&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span lang="EN-US">
          <a href="mailto:support@carson.live" target="_self">
            <span lang="FR-CA">support@carson.live </span>
          </a>
        </span>
      </p>

      <div>
        <p className="MsoNormal">
          <span lang="FR-CA">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span lang="EN-US">
            <a href="mailto:privacy@carson.live">
              <span lang="FR-CA">privacy@carson.live</span>
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);
